import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { UzurvRestConfiguration, UzurvRestService, UZURV_REST_CONFIGURATION } from '@uzurv/http';
import { Deserialize } from 'cerialize';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ServiceLevel } from '../../models';

@Injectable({providedIn: 'root'})
export class ServiceLevelService  extends UzurvRestService  {
  readonly resourceUrl = 'serviceLevels/';

  constructor(
    httpClient: HttpClient,
    @Inject(UZURV_REST_CONFIGURATION)
    protected uzurvRestConfiguration: UzurvRestConfiguration,
    domSanitizer: DomSanitizer
  ) {
    super(httpClient, uzurvRestConfiguration, domSanitizer);
  }

  listAll(pageNumber: number, pageSize: number): Observable<Array<ServiceLevel>> {
    return this.get<Array<ServiceLevel>>(this.resourceUrl, { pageNumber, pageSize }).pipe(map(serviceLevels => Deserialize(serviceLevels, ServiceLevel)));
  }

}
